import ContainerWrapper from '@containers/com/ContainerWrapper';
import { useEffect } from 'react';

const Main = () => {
  useEffect(() => {}, []);

  return <ContainerWrapper />;
};

export default Main;
